import React from "react";
import { CheckCircle } from "lucide-react";
import Restaurantcycle from "./Restaurantcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Grow Your Restaurant & Food Business with WhatsApp Magic",
  points: [
    "Showcase your delicious menu using WhatsApp Catalogs.",
    "Let customers order and pay directly through WhatsApp for convenience.",
    "Provide 24/7 support to ensure every customer feels valued.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]",buttonLink:"https://app.chatmitra.com/signin" },
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_1.png",
};

const restaurantServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🍽️</span>, // Plate icon
    title: "Boost Reservations with WhatsApp",
    description: "Let customers book tables, order takeout, or plan events via WhatsApp. It’s like having a hostess who’s always available to help!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🍕</span>, // Pizza icon
    title: "Promote Menus on WhatsApp",
    description: "Share daily specials, seasonal dishes, and new launches through WhatsApp. Your diners will be tempted to order more often."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📦</span>, // Package icon
    title: "Track Deliveries via WhatsApp",
    description: "Keep customers updated on order status, delays, and arrivals with WhatsApp. They’ll love the transparency and peace of mind."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Customer Service on WhatsApp",
    description: "Answer dietary questions, handle complaints, and provide recommendations via WhatsApp. Your guests will feel valued and cared for."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Manage Events on WhatsApp",
    description: "Coordinate private dinners, parties, or catering requests through WhatsApp. It’s a seamless way to impress clients and grow revenue."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Collect Reviews via WhatsApp",
    description: "Ask for feedback on food, service, or ambiance through WhatsApp. It’s a simple way to improve and attract more diners."
  }
];


const restaurantFAQs = [
  {
    question: "How can WhatsApp grow my restaurant business?",
    answer: "WhatsApp can boost your reservations and orders by sending menu specials and event invites directly to customers. It’s like having a waiter who’s always ready to take your order!"
  },
  {
    question: "Is WhatsApp secure for food orders?",
    answer: "Yes, WhatsApp’s encryption keeps your orders and customer data safe. It’s like locking your menu in a vault, so clients can order with confidence."
  },
  {
    question: "Can customers book tables on WhatsApp?",
    answer: "Absolutely! They can reserve seats, order takeout, or plan events via WhatsApp. It’s like having a hostess available 24/7, making dining a snap."
  },
  {
    question: "How does WhatsApp handle food delivery updates?",
    answer: "Send real-time updates on order status, delays, and arrivals via WhatsApp. It’s like giving diners a personal tracker, keeping them happy and informed."
  },
  {
    question: "What food content should I share on WhatsApp?",
    answer: "Share daily specials, chef recommendations, and holiday menus via WhatsApp. It’s a direct line to tempt taste buds and drive more foot traffic."
  },
  {
    question: "Can WhatsApp manage catering requests?",
    answer: "Yes! Coordinate event catering, send quotes, and confirm details through WhatsApp. It’s like having a catering coordinator who handles everything seamlessly."
  },
  {
    question: "How do diners feel about using WhatsApp for restaurants?",
    answer: "They love it! Diners appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than calls and more immediate, making ordering a pleasure."
  },
  {
    question: "Can WhatsApp reduce my restaurant’s workload?",
    answer: "Definitely! Automate responses to queries and handle bookings via WhatsApp, freeing your staff for cooking and serving. It’s like having an extra hand in the kitchen!"
  },
  {
    question: "How can I collect feedback on WhatsApp for my restaurant?",
    answer: "Send surveys or ask for reviews on food and service via WhatsApp. It’s a quick way to improve and show customers you value their opinions."
  },
  {
    question: "How do I set up WhatsApp for my food business?",
    answer: "Start with WhatsApp Business, create chat templates for orders and promotions, and use tools like ChatMitra. It’s a magical step to grow your restaurant!"
  },
];

const Restaurant = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Grow Your Restaurant & Food Business with WhatsApp Magic</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
               <a
               key={index}
               href={button.buttonLink}
               className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
             >
               {button.text}
             </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Restaurant Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Boost your restaurant growth with seamless WhatsApp solutions. Sign up today with ChatMitra and start transforming customer experiences!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Restaurantcycle />

      <WhatsAppServices servicesData={restaurantServices} isVisible={true}/>
      <Faqs faqs={restaurantFAQs} />
      <title>Boost Your Restaurant with WhatsApp | Orders, Payments, & Support</title>
      <meta name="description" content="Use WhatsApp to promote menus, accept orders and payments, and offer 24/7 support for your restaurant or food business with ChatMitra." />
      <meta name="keywords" content="WhatsApp for restaurants, food business WhatsApp, restaurant orders, menu promotion, customer support WhatsApp, food delivery tracking" />
      <meta property="og:title" content="Boost Your Restaurant with WhatsApp | Orders, Payments, & Support" />
      <meta property="og:description" content="Learn how WhatsApp helps restaurants streamline orders, process payments, and engage customers with personalized support." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-restaurants-food-businesses" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default Restaurant;